<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PYTrJ7/tc-custom/9781788855419.jpg?1728326834187" alt="This image is the cover for the book Cat for the Keeper"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cat for the Keeper
      </h1>
      <p class="bookDescription body article font2">
        <p>‘A heartwarming little tale’ – Peter May  The lighthouse keeper needed a new cat and I knew I had the perfect replacement. But this journey had begun long before I boarded the boat to the island . . .</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lilly Hurd
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Birlinn
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d154dedc